import { GRADES } from "@/lib/grades";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Editor for a { "1st Year": 45, ... } grade -> charge-rate map.
export function GradeRateEditor({ value, onChange, label }) {
  const v = value || {};
  const set = (g, raw) => {
    const next = { ...v };
    if (raw === "" || raw == null) delete next[g];
    else next[g] = Number(raw);
    onChange(next);
  };
  return (
    <div>
      <Label>{label || "Charge rates by Type (€/hr)"}</Label>
      <div className="grid grid-cols-2 gap-2 mt-1">
        {GRADES.map((g) => (
          <div key={g} className="flex items-center gap-2">
            <span className="text-xs text-zinc-500 w-24 shrink-0">{g}</span>
            <Input
              data-testid={`grade-rate-${g.replace(/\s+/g, "-").toLowerCase()}`}
              type="number"
              step="0.5"
              placeholder="—"
              value={v[g] ?? ""}
              onChange={(e) => set(g, e.target.value)}
              className="h-9"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
